let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fiOV9")).then(() => parcelRequire('lY7ys'));